(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    /* ---------------------------------------------------------------- */
    /* Waitlist dialog — single-step state machine                      */
    /* ---------------------------------------------------------------- */
    var root = document.querySelector("[data-waitlist-root]");
    var lastTrigger = null;

    function getStep(n) {
      if (!root) return null;
      return root.querySelector("[data-waitlist-step='" + n + "']");
    }

    function showStep(n) {
      if (!root) return;
      for (var i = 1; i <= 2; i++) {
        var el = getStep(i);
        if (!el) continue;
        el.hidden = i !== n;
      }
    }

    function showError(message) {
      if (!root) return;
      var err = root.querySelector("[data-waitlist-error]");
      if (err) {
        err.textContent = message;
        err.hidden = false;
      }
    }

    function clearError() {
      if (!root) return;
      var err = root.querySelector("[data-waitlist-error]");
      if (err) {
        err.textContent = "";
        err.hidden = true;
      }
    }

    function setLoading(form, isLoading) {
      if (!form) return;
      var submit = form.querySelector("[data-waitlist-submit]");
      var idle = form.querySelector("[data-waitlist-submit-idle]");
      var loading = form.querySelector("[data-waitlist-submit-loading]");
      var inputs = form.querySelectorAll("input");
      if (submit) submit.disabled = !!isLoading;
      if (idle) idle.hidden = !!isLoading;
      if (loading) loading.hidden = !isLoading;
      Array.prototype.forEach.call(inputs, function (i) { i.disabled = !!isLoading; });
    }

    function resetDialog() {
      if (!root) return;
      var form = root.querySelector("[data-waitlist-form]");
      if (form) {
        try { form.reset(); } catch (e) {}
        setLoading(form, false);
      }
      clearError();
      showStep(1);
    }

    function openDialog(trigger) {
      if (!root) return;
      lastTrigger = trigger || null;
      clearError();
      showStep(1);
      root.classList.add("is-open");
      var step1 = getStep(1);
      var firstInput = step1 ? step1.querySelector("input[name='name']") : null;
      if (firstInput) {
        try { firstInput.focus(); } catch (e) {}
      }
    }

    function closeDialog() {
      if (!root || !root.classList.contains("is-open")) return;
      root.classList.remove("is-open");
      if (lastTrigger) {
        try { lastTrigger.focus(); } catch (e) {}
      }
      lastTrigger = null;
      window.setTimeout(resetDialog, 200);
    }

    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;

      var openBtn = e.target.closest("[data-waitlist-open]");
      if (openBtn) {
        e.preventDefault();
        openDialog(openBtn);
        return;
      }

      var closeBtn = e.target.closest("[data-waitlist-close]");
      if (closeBtn) {
        e.preventDefault();
        closeDialog();
        return;
      }

      if (root && root.classList.contains("is-open")) {
        var overlay = e.target.closest("[data-waitlist-overlay]");
        if (overlay) {
          closeDialog();
        }
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        closeDialog();
      }
    });

    function fieldValue(form, fieldName) {
      var el = form.querySelector("[name='" + fieldName + "']");
      return el ? el.value : "";
    }

    function isChecked(form, fieldName) {
      var el = form.querySelector("[name='" + fieldName + "']");
      return el ? !!el.checked : false;
    }

    function klaviyoSubscribe(payload) {
      var slou = window.SLOU || {};
      var publicKey = slou.klaviyoPublicKey || "";
      if (!publicKey) {
        return Promise.resolve({ ok: true, skipped: true });
      }
      return fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" +
          encodeURIComponent(publicKey),
        {
          method: "POST",
          headers: {
            revision: "2024-10-15",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      ).then(function (res) {
        return {
          ok: !!(res && res.status >= 200 && res.status < 300),
          skipped: false
        };
      });
    }

    function buildPayload(listId, profileAttrs) {
      return {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: profileAttrs
              }
            }
          },
          relationships: {
            list: {
              data: { type: "list", id: listId }
            }
          }
        }
      };
    }

    var waitlistForm = root ? root.querySelector("[data-waitlist-form]") : null;
    if (waitlistForm) {
      waitlistForm.addEventListener("submit", function (e) {
        e.preventDefault();
        clearError();

        var name = fieldValue(waitlistForm, "name").trim();
        var email = fieldValue(waitlistForm, "email").trim();
        var phoneRaw = fieldValue(waitlistForm, "phone").trim();
        var consent = isChecked(waitlistForm, "consent");

        if (name.length < 1 || name.length > 80) {
          showError("please enter your name");
          return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 255) {
          showError("please enter a valid email");
          return;
        }
        if (phoneRaw && !/^[+\d\s()-]{6,20}$/.test(phoneRaw)) {
          showError("please enter a valid phone number");
          return;
        }
        if (!consent) {
          showError("please accept to be contacted to continue");
          return;
        }

        var phone = phoneRaw ? phoneRaw.replace(/[\s()-]/g, "") : "";
        var parts = name.split(/\s+/);
        var firstName = parts.shift();
        var lastName = parts.join(" ");

        var slou = window.SLOU || {};
        var publicKey = slou.klaviyoPublicKey || "";
        var listId = slou.klaviyoListId || "";

        if (!publicKey || !listId) {
          showStep(2);
          return;
        }

        var profileAttrs = {
          email: email,
          first_name: firstName,
          properties: {
            source: "waitlist landing",
            consent_text: "i agree to be contacted with updates about the drop and exclusive offers."
          }
        };
        if (lastName) profileAttrs.last_name = lastName;
        if (phone) profileAttrs.phone_number = phone;

        setLoading(waitlistForm, true);

        klaviyoSubscribe(buildPayload(listId, profileAttrs))
          .then(function (result) {
            setLoading(waitlistForm, false);
            if (result.ok) {
              showStep(2);
            } else {
              showError("something went wrong, please try again");
            }
          })
          .catch(function () {
            setLoading(waitlistForm, false);
            showError("something went wrong, please try again");
          });
      });
    }

    /* ---------------------------------------------------------------- */
    /* FAQ accordion (single + collapsible)                             */
    /* ---------------------------------------------------------------- */
    var accordions = document.querySelectorAll("[data-accordion]");
    Array.prototype.forEach.call(accordions, function (accordion) {
      var triggers = accordion.querySelectorAll("[data-accordion-trigger]");

      function contentOf(trigger) {
        var item = trigger.closest("[data-accordion-item]");
        return item ? item.querySelector("[data-accordion-content]") : null;
      }

      function close(trigger) {
        var content = contentOf(trigger);
        trigger.setAttribute("data-state", "closed");
        if (content) {
          content.style.height = content.scrollHeight + "px";
          void content.offsetHeight;
          content.style.height = "0px";
        }
      }

      function open(trigger) {
        var content = contentOf(trigger);
        trigger.setAttribute("data-state", "open");
        if (content) {
          content.style.height = content.scrollHeight + "px";
        }
      }

      Array.prototype.forEach.call(triggers, function (trigger) {
        var content = contentOf(trigger);
        if (content) content.style.height = "0px";

        trigger.addEventListener("click", function () {
          var isOpen = trigger.getAttribute("data-state") === "open";
          if (isOpen) {
            close(trigger);
          } else {
            Array.prototype.forEach.call(triggers, function (other) {
              if (other !== trigger && other.getAttribute("data-state") === "open") {
                close(other);
              }
            });
            open(trigger);
          }
        });

        if (content) {
          content.addEventListener("transitionend", function (ev) {
            if (ev.propertyName !== "height") return;
            if (trigger.getAttribute("data-state") === "open") {
              content.style.height = "auto";
            }
          });
        }
      });
    });

    /* ---------------------------------------------------------------- */
    /* Prototype gallery                                                */
    /* ---------------------------------------------------------------- */
    var THUMB_ACTIVE =
      "overflow-hidden rounded-[16px] bg-background ring-2 transition ring-foreground";
    var THUMB_INACTIVE =
      "overflow-hidden rounded-[16px] bg-background ring-2 transition ring-transparent hover:ring-border";
    var DOT_ACTIVE = "h-1.5 rounded-full transition-all w-5 bg-foreground";
    var DOT_INACTIVE = "h-1.5 rounded-full transition-all w-1.5 bg-foreground/20";

    var protoMainBtn = document.querySelector("[data-proto-main]");
    var protoMainImg = protoMainBtn ? protoMainBtn.querySelector("img") : null;
    var thumbs = document.querySelectorAll("[data-proto-thumb]");
    var dots = document.querySelectorAll("[data-proto-dot]");

    function urlForIndex(index) {
      if (!protoMainBtn) return "";
      if (index === "-1" || index === -1) {
        return protoMainBtn.getAttribute("data-src-hero") || "";
      }
      if (index === "0" || index === 0) {
        return protoMainBtn.getAttribute("data-src-front") || "";
      }
      if (index === "1" || index === 1) {
        return protoMainBtn.getAttribute("data-src-side") || "";
      }
      if (index === "2" || index === 2) {
        return protoMainBtn.getAttribute("data-src-back") || "";
      }
      return "";
    }

    function setActiveProto(index) {
      var indexStr = String(index);

      if (protoMainImg) {
        var nextSrc = urlForIndex(indexStr);
        if (nextSrc) protoMainImg.src = nextSrc;
      }

      Array.prototype.forEach.call(thumbs, function (thumb) {
        var i = thumb.getAttribute("data-proto-thumb");
        if (i === indexStr) {
          thumb.className = THUMB_ACTIVE;
          thumb.setAttribute("data-active", "true");
        } else {
          thumb.className = THUMB_INACTIVE;
          thumb.setAttribute("data-active", "false");
        }
      });
      Array.prototype.forEach.call(dots, function (dot) {
        var i = dot.getAttribute("data-proto-dot");
        if (i === indexStr) {
          dot.className = DOT_ACTIVE;
          dot.setAttribute("data-active", "true");
        } else {
          dot.className = DOT_INACTIVE;
          dot.removeAttribute("data-active");
        }
      });
    }

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener("click", function () {
        setActiveProto(thumb.getAttribute("data-proto-thumb"));
      });
    });

    if (protoMainBtn) {
      protoMainBtn.addEventListener("click", function () {
        setActiveProto("-1");
      });
    }

    /* ---------------------------------------------------------------- */
    /* Sticky CTA: smooth scroll + hide on waitlist + footer            */
    /* ---------------------------------------------------------------- */
    document.addEventListener("click", function (e) {
      var scrollBtn = e.target.closest
        ? e.target.closest("[data-scroll-to='waitlist']")
        : null;
      if (!scrollBtn) return;
      e.preventDefault();
      var target = document.getElementById("waitlist");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    var stickyWrap = document.querySelector("[data-sticky-cta]");
    if (stickyWrap && typeof IntersectionObserver !== "undefined") {
      var stickyBtn = stickyWrap.querySelector("button");
      var waitlistVisible = false;
      var footerVisible = false;

      function applyStickyState() {
        var hidden = waitlistVisible || footerVisible;
        if (hidden) {
          stickyWrap.classList.add("translate-y-[120%]");
          stickyWrap.classList.add("opacity-0");
          stickyWrap.classList.remove("translate-y-0");
          stickyWrap.classList.remove("opacity-100");
          stickyWrap.setAttribute("aria-hidden", "true");
          if (stickyBtn) stickyBtn.setAttribute("tabindex", "-1");
        } else {
          stickyWrap.classList.remove("translate-y-[120%]");
          stickyWrap.classList.remove("opacity-0");
          stickyWrap.classList.add("translate-y-0");
          stickyWrap.classList.add("opacity-100");
          stickyWrap.setAttribute("aria-hidden", "false");
          if (stickyBtn) stickyBtn.setAttribute("tabindex", "0");
        }
      }

      var waitlistTarget = document.getElementById("waitlist");
      if (waitlistTarget) {
        var obs1 = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (!entry) return;
            waitlistVisible = entry.isIntersecting;
            applyStickyState();
          },
          { threshold: 0.1, rootMargin: "0px 0px -80px 0px" }
        );
        obs1.observe(waitlistTarget);
      }

      var footerTarget = document.getElementById("footer");
      if (footerTarget) {
        var obs2 = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (!entry) return;
            footerVisible = entry.isIntersecting;
            applyStickyState();
          },
          { threshold: 0 }
        );
        obs2.observe(footerTarget);
      }
    }
  });
})();
